import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../hooks';
import { Device } from '../components/Device';
export const PageDevice = () => {
    const { id } = useParams();
    const num_devices = useAppSelector(state => Object.keys(state.definitions.devices).length);
    const device_id = Number(id);
    const hasDefinitions = num_devices > 0;
    if (isNaN(device_id)) {
        return null;
    }
    const content = hasDefinitions && !isNaN(device_id) ? _jsx(Device, { id: device_id }) : '... loading data ...';
    return (_jsx("div", { className: "page-container", children: _jsx("div", { className: "device", children: content }) }));
};
